import { render, staticRenderFns } from "./BabyDatasheet.vue?vue&type=template&id=0a4bf7f8&scoped=true"
import script from "./BabyDatasheet.vue?vue&type=script&lang=js"
export * from "./BabyDatasheet.vue?vue&type=script&lang=js"
import style0 from "./BabyDatasheet.vue?vue&type=style&index=0&id=0a4bf7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bf7f8",
  null
  
)

export default component.exports